import React from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import {
  ToggleSwitch,
  ToggleTitleWrapper,
} from "../../styled/ToggleTile.styled";
import StyleTooltip from "./StyleTooltip";

const StyledGridContainer = styled(Grid)`
  && {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px; /* Adjust as needed */
  }
`;

const CommonToggleWrapper = ({ filtersArray = [], onChangeStatusFilter, tooltip = null }) => {
  return (
    <>
      {filtersArray.length > 0 &&
        filtersArray.map((item, index) => (
          <StyledGridContainer
            key={index}
            container
            xs={12}
            sm={12}
            md={12}
            item
          >
            {tooltip && !item.disabled
              ? <StyleTooltip title={tooltip}>
                <ToggleTitleWrapper>{item.label || item.filterName}</ToggleTitleWrapper>
              </StyleTooltip>
              : <ToggleTitleWrapper>{item.label || item.filterName}</ToggleTitleWrapper>}
            <ToggleSwitch
              checked={item.isChecked}
              disabled={item.disabled}
              onChange={() => {
                onChangeStatusFilter({ ...item, isChecked: !item.isChecked });
              }}
            />
          </StyledGridContainer>
        ))}
    </>
  );
};

export default CommonToggleWrapper;
